import * as React from "react"

const Spacer = ({className}) => (
  <div className={"spacer " + (className ? className : '')}></div> 
) 
export default Spacer
